import axios from "axios";
import { addAuthenticationInterceptor } from "./interceptors/authenticationInterceptor";
import { addTimeoutInterceptor } from "./interceptors/timeoutInterceptor";
import config from "@/config.ts";

const axiosClient = axios.create({
  // baseURL: `http://localhost:4080/api`,
  baseURL: config.apiBaseUrl,
});

addAuthenticationInterceptor(axiosClient);
addTimeoutInterceptor(axiosClient);

export default axiosClient;
